import { render, staticRenderFns } from "./FeatureRow.vue?vue&type=template&id=2a65ce5a&scoped=true&"
import script from "./FeatureRow.vue?vue&type=script&lang=js&"
export * from "./FeatureRow.vue?vue&type=script&lang=js&"
import style0 from "./FeatureRow.vue?vue&type=style&index=0&id=2a65ce5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a65ce5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
